import { React, lazy, useState, useEffect, Suspense } from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
// import BrandOne from "../components/BrandOne";
// import FeatureOne from "../components/FeatureOne";
// import PromotionalOne from "../components/PromotionalOne";
// import FlashSalesOne from "../components/FlashSalesOne";
import OfferOne from "../components/OfferOne";
// import DeliveryOne from "../components/DeliveryOne";
// import BrandOne from "../components/BrandOne";

// import NewsletterOne from "../components/NewsletterOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
// import HotDealsOne from "../components/HotDealsOne";
// import ProductListOne from "../components/landing_page_products/ProductListOne";
//import CategoriesArea from "../components/landing_page_products/CategoriesArea";
// import OrganicOne from "../components/landing_page_products/OrganicOne";
// import TopVendorsOne from "../components/TopVendorsOne";
// import BestSellsOne from "../components/BestSellsOne";
// import ShortProductOne from "../components/ShortProductOne";
// import ShippingOne from "../components/ShippingOne";
// import RecommendedOne from "../components/RecommendedOne";
// import NewArrivalOne from "../components/NewArrivalOne";

const LazyComponent2 = lazy(() => import("../components/HotDealsOne"));
const LazyComponent = lazy(() =>
  import("../components/landing_page_products/ProductListOne")
);
const LazyComponent3 = lazy(() =>
  import("../components/landing_page_products/CategoriesArea")
);
const LazyComponent4 = lazy(() =>
  import("../components/landing_page_products/OrganicOne")
);
const LazyComponent5 = lazy(() => import("../components/BrandOne"));
const LazyComponent6 = lazy(() => import("../components/NewsletterOne"));
const LazyComponent7 = lazy(() => import("../components/DeliveryOne"));
const LazyComponent8 = lazy(() => import("../components/FeatureOne"));
const LazyComponent9 = lazy(() => import("../components/PromotionalOne"));
const LazyComponent10 = lazy(() => import("../components/FlashSalesOne"));
const LazyComponent11 = lazy(() => import("../components/BannerOne"));

const HomePageOne = () => {
  const [showComponents, setShowComponents] = useState(false);
  const [showComponent2, setShowComponent2] = useState(false);
  const [showComponent3, setShowComponent3] = useState(false);
  const [showComponent4, setShowComponent4] = useState(false);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowComponents(true);
  //   }, 3000);

  //   return () => clearTimeout(timer);
  // }, []);
  useEffect(() => {
    setTimeout(() => setShowComponents(true), 1000);
    setTimeout(() => setShowComponent2(true), 1000);
    setTimeout(() => setShowComponent3(true), 2000); // Second component after 5s
    setTimeout(() => setShowComponent4(true), 4000); // Second component after 5s
  }, []);

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#4887c7" />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* HeaderOne */}
      <HeaderOne />

      {/* BannerOne */}
      {/* <BannerOne />*/}

      {/* FeatureOne */}
      {/* <FeatureOne /> */}

      {/* PromotionalOne */}
      {/* <PromotionalOne /> */}

      {/* FlashSalesOne */}
      {/* <FlashSalesOne /> */}

      {/* ProductListOne */}
      {/* <ProductListOne /> */}
      {showComponents && (
        <Suspense fallback={<div></div>}>
          <LazyComponent11 />
          <LazyComponent8 />
          <LazyComponent9 />
          <LazyComponent10 />
          <LazyComponent />
        </Suspense>
      )}

      {/* OfferOne */}
      <OfferOne />

      {/* HotDealsOne */}
      {/* <HotDealsOne /> */}
      {showComponent2 && (
        <Suspense fallback={<div></div>}>
          <LazyComponent2 />
        </Suspense>
      )}

      {/* NewArrivalOne */}
      {/* <NewArrivalOne /> */}

      {/* categoriesArea */}
      {/* <CategoriesArea /> */}
      {showComponent3 && (
        <Suspense fallback={<div></div>}>
          <LazyComponent3 />
        </Suspense>
      )}

      {/* RecommendedOne */}
      {/* <RecommendedOne /> */}

      {/* TopVendorsOne */}
      {/* <TopVendorsOne /> */}

      {/* BestSellsOne */}
      {/* <BestSellsOne /> */}

      {/* DeliveryOne */}
      {/* <DeliveryOne /> */}

      {/* OrganicOne */}
      {/* <OrganicOne /> */}
      {showComponent4 && (
        <Suspense fallback={<div></div>}>
          <LazyComponent7 />
          <LazyComponent4 />
          <LazyComponent5 />
          <LazyComponent6 />
        </Suspense>
      )}

      {/* ShortProductOne */}
      {/* <ShortProductOne /> */}

      {/* BrandOne */}
      {/* <BrandOne /> */}

      {/* ShippingOne */}
      {/* <ShippingOne /> */}

      {/* NewsletterOne */}
      {/* <NewsletterOne /> */}

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default HomePageOne;
